export default __webpack_public_path__ + "static/media/ethics.f9ca433d.md";